module.exports = __webpack_public_path__ + "img/LOGO_GRUPO_MERCA.8188a1cb.png";